
<div class="json-editor-container" [class.dark-theme]="isDarkTheme">
<div class="toolbar">
  <button (click)="format()" class="btn-normal">格式化</button>
  <button (click)="compact()" class="btn-normal">壓縮</button>
  <button (click)="copyToClipboard()" class="btn-normal">複製</button>
  <button (click)="toggleTheme()" class="btn-normal theme-toggle">
    {{ isDarkTheme ? '淺色' : '深色' }}
  </button>
</div>

<div class="editor-wrapper">
  <div class="line-numbers" #lineNumbers>
    @for (line of lineNumbersArray; track line) {
      <div class="line-number">{{line}}</div>
    }
  </div>
  <textarea
    #editorTextarea
    [(value)]="content"
    (input)="onContentChange($event)"
    (scroll)="syncScroll($event)"
    [class.error]="hasError"
    rows="10"
    placeholder="請輸入JSON數據..."
    spellcheck="false"
  ></textarea>
</div>

@if (hasError) {
  <div class="error-message">
    {{ errorMessage }}
  </div>
}
</div>
